export function ratioAsNumber(ratio: string): number {
  const [width, height] = ratio.split("x").map((v) => parseFloat(v));
  return width / height;
}
